import * as React from 'react';

import { EngineRenderers } from '@websky/core/src/renderProps';
import Notification from '@websky/core/src/Notification/components/Notification';
import * as theme from './Notification.css';

const CheckinNotification: EngineRenderers['CheckinNotification'] = props => {
	return <Notification {...props} className={theme.wrapper} />;
};

export default CheckinNotification;
